import { useCallback, useEffect, useState, useRef } from "react";
import FieldPulse                                   from "../services/fieldpulse";

export default function useCustomerSearch({
  search = "",
  limit = 50,
  page = 1,
}) {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);

  let timeout = useRef().current;
  let term = useRef().current;

  const searchCustomers = useCallback(async () => {
    setCustomers([]);
    if (loading || search.length < 3) return;
    setLoading(true);
    const res = await FieldPulse.searchContactCustomers({
      page,
      limit,
      search,
    });
    if (res.error) {
      setError(res.message);
    } else {
      setCustomers(res.response || []);
    }
    setLoading(false);
  }, [loading, page, limit, search, setError, setCustomers, setLoading]);


  useEffect(() => {
    if (timeout) clearTimeout(timeout);
    if ((search && !customers) || search !== term) {
      timeout = setTimeout(() => {
        term = search;
        searchCustomers(search);
      }, 300);
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [search, page, limit, term]);

  return {
    customers,
    error,
    loading,
    search,
    limit,
    page,
    searchCustomers,
  };
}
